import { DetectorMapActionTypes, AddDetectorMaps, ModifyDetectorMaps, DeleteDetectorMaps } from 'Actions/ActionTypes/index';
import { DetectorMap, Id } from 'NSwag/ServerClient/Client.nswag';

/**
 * Defines methods that create action objects for Detector Mappings in the store
 */

export const addDetectorMaps = (detectorMaps: DetectorMap[]): AddDetectorMaps => ({
    type: DetectorMapActionTypes.AddMaps as DetectorMapActionTypes.AddMaps,
    detectorMaps
});

export const modifyDetectorMaps = (detectorMaps: DetectorMap[]): ModifyDetectorMaps => ({
    type: DetectorMapActionTypes.ModifyMaps as DetectorMapActionTypes.ModifyMaps,
    detectorMaps
});

export const deleteDetectorMaps = (ids: Id[]): DeleteDetectorMaps => ({
    type: DetectorMapActionTypes.DeleteMaps as DetectorMapActionTypes.DeleteMaps,
    ids
});

export type DetectorMapAction = ReturnType<typeof addDetectorMaps | typeof modifyDetectorMaps | typeof deleteDetectorMaps>